module.exports = "<div class=\"font-13\">{{godina}} © <b>Holspico - Virtualna učionica</b></div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/layouts/app-footer/app-footer.component.html
// module id = ../../../../../src/app/layouts/app-footer/app-footer.component.html
// module chunks = main